<template>
  <div class="wrapper login">
    <div class="logo">在艺</div>
    <div class="login-box">
      <div class="form-group">
        <PhoneCode-select v-model="form.phoneCode"></PhoneCode-select>
        <input type="tel" class="form-controls" placeholder="请输入手机号" v-model="form.phone">
      </div>
      <div class="form-group" v-if="isShowImageCode">
        <input
          type="text"
          class="form-controls"
          placeholder="请输入图片中的验证码"
          v-model="form.imageVerifyCode"
        >
        <image-code v-model="form.sessionId"></image-code>
      </div>
      <div class="form-group">
        <input
          type="tel"
          class="form-controls"
          placeholder="请输入短信验证码"
          maxlength="6"
          v-model="form.verifyCode"
          @keyup.enter="login"
        >
        <countdown-button ref="countdown" @click.native="sendCode"></countdown-button>
      </div>
      <div class="form-group">
        <input type="button" class="btn btn-primary btn-login" value="登录" @click="login">
      </div>
    </div>
    <div class="login-bar" v-if="!isWechat">
      <p class="tips">或</p>
      <ul class="login-third">
        <li class="login-wechat" @click="onWechatLogin">微信</li>
        <!-- <li class="login-sina" @click="weiboLogin">微博</li>
        <li class="login-qq" @click="qqLogin">QQ</li>-->
      </ul>
    </div>
  </div>
</template>
<script>
import Cookies from 'js-cookie'
import thirdConfig from '@/utils/third'
import { isWechat, isZaiart } from '@/utils/utils'
import PhoneCodeSelect from '@/components/PhoneCodeSelect'
import CountdownButton from '@/components/CountdownButton'
import ImageCode from '@/components/ImageCode'
import {
  phoneLogin,
  thirdLogin,
  thirdLogin2,
  getThirdUser,
  getCode
} from '@/api/login'
import { sendCode, heartbeat } from '@/api/base'
import { share } from '@/utils/share'

export default {
  name: 'Login',
  components: { PhoneCodeSelect, CountdownButton, ImageCode },
  metaInfo: { title: '登录' },
  data() {
    return {
      isZaiart: isZaiart,
      isWechat: isWechat,
      form: {
        appId: '',
        code: '',
        loginType: '',
        phoneCode: '+86',
        phone: '',
        imageVerifyCode: '',
        sessionId: Math.random()
          .toString(36)
          .substr(2),
        verifyCode: ''
      },
      redirect_uri: '',
      isShowImageCode: false // 显示图片验证码
    }
  },
  methods: {
    // 发送验证码
    sendCode() {
      let param = {
        account: this.form.phoneCode + ' ' + this.form.phone,
        imageVerifyCode: this.form.imageVerifyCode,
        sendFuncType: 'PHONE_VERIFY_CODE_LOGIN',
        sessionId: this.form.sessionId
      }
      if (!this.form.phone) {
        this.$toast('请输入手机号')
        return false
      } else if (!param.imageVerifyCode) {
        this.$toast('请输入图片中的验证码')
        return false
      }
      // 验证码倒计时开始
      this.$refs.countdown.start()
      sendCode(param).catch(response => {
        this.$refs.countdown.stop()
        // 图形验证码错误，显示手动输入图形验证码
        if (response.code === 8000002 && !this.isShowImageCode) {
          this.isShowImageCode = true
          this.form.imageVerifyCode = ''
        }
      })
    },
    // 登录
    login() {
      let param = {
        appId: this.form.appId,
        code: this.form.code,
        loginType: this.form.loginType,
        phone: this.form.phoneCode + ' ' + this.form.phone,
        verifyCode: this.form.verifyCode,
        utmSource: this.redirect_uri || location.href
      }
      if (!this.form.phone) {
        this.$toast('请输入手机号')
        return false
      } else if (!param.verifyCode) {
        this.$toast('请输入短信验证码')
        return false
      }
      phoneLogin(param).then(response => {
        this.loginSuccess(response.data)
      })
    },
    onWechatLogin() {
      if (this.isWechat) {
        // 微信自动登录
        this.wechatLogin()
      } else {
        // 微信扫码登录
        this.wechatQrLogin()
      }
    },
    // 微信扫码登录
    wechatQrLogin() {
      Cookies.remove('token', { domain: process.env.VUE_APP_COOKIES_DOMAIN })
      thirdConfig.wechat.redirect_uri += `?appid=${
        thirdConfig.wechat.appid
      }&redirect_uri=${encodeURIComponent(
        process.env.VUE_APP_LOCATION_URL +
          `/#/login?required_phone=${this.required_phone}&redirect_uri=` +
          encodeURIComponent(this.redirect_uri)
      )}`
      window.location.href = this.json2Url(thirdConfig.wechat)
    },
    // 微信自动登录
    wechatLogin() {
      Cookies.remove('token', { domain: process.env.VUE_APP_COOKIES_DOMAIN })
      thirdConfig.mpWechat.redirect_uri += `?appid=${
        thirdConfig.mpWechat.appid
      }&redirect_uri=${encodeURIComponent(
        process.env.VUE_APP_LOCATION_URL +
          `/#/login?required_phone=${this.required_phone}&redirect_uri=` +
          encodeURIComponent(this.redirect_uri)
      )}`
      window.location.href = this.json2Url(thirdConfig.mpWechat)
    },
    // 微博登录
    weiboLogin() {
      Cookies.remove('token', { domain: process.env.VUE_APP_COOKIES_DOMAIN })
      thirdConfig.weibo.redirect_uri += `?appid=${
        thirdConfig.weibo.client_id
      }&redirect_uri=${encodeURIComponent(
        process.env.VUE_APP_LOCATION_URL +
          `/#/login?required_phone=${this.required_phone}&redirect_uri=` +
          encodeURIComponent(this.redirect_uri)
      )}`
      window.location.href = this.json2Url(thirdConfig.weibo)
    },
    // qq登录
    qqLogin() {
      Cookies.remove('token', { domain: process.env.VUE_APP_COOKIES_DOMAIN })
      thirdConfig.qq.redirect_uri += `?appid=${
        thirdConfig.qq.client_id
      }&redirect_uri=${encodeURIComponent(
        process.env.VUE_APP_LOCATION_URL +
          `/#/login?required_phone=${this.required_phone}&redirect_uri=` +
          encodeURIComponent(this.redirect_uri)
      )}`
      window.location.href = this.json2Url(thirdConfig.qq)
    },
    // 在艺登录
    zaiartLogin() {
      Cookies.remove('token', { domain: process.env.VUE_APP_COOKIES_DOMAIN })
      /* 统一调用方法 */
      window.zaiyi_login_callback = function(loginUserData) {
        loginUserData = (loginUserData && JSON.parse(loginUserData)) || {}
        if (loginUserData.status === '0') {
          this.loginSuccess(loginUserData.data)
        }
      }.bind(this)
      /* Android */
      window.localAndroid &&
        window.localAndroid.innerWebLogin(
          JSON.stringify({
            param: {}
          })
        )
      /* IOS */
      window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.innerWebLogin &&
        window.webkit.messageHandlers.innerWebLogin.postMessage(
          JSON.stringify({
            param: {}
          })
        )
    },
    // 第三方接口登录
    thirdLogin() {
      let code = this.$route.query.code
      let state = this.$route.query.state
      if (!code && !state) {
        return false
      }
      let options = { 3: thirdConfig.qq, 5: thirdConfig.weibo }
      options[4] = this.isWechat ? thirdConfig.mpWechat : thirdConfig.wechat
      let loginOptions = options[state] || {}
      let param = {
        code: code,
        loginType: state,
        appId: loginOptions.appid || loginOptions.client_id,
        utmSource: this.redirect_uri || location.href
      }
      if (this.required_phone === '1') {
        thirdLogin(param)
          .then(response => {
            // 支付需要openId，非在艺用户openId
            // this.loginSuccess(response.data)
            this.getThirdUser(param).then(() => {
              this.loginSuccess(response.data)
            })
          })
          .catch(response => {
            if (response.code === 30402) {
              // 30402第三方登录未注册，跳转绑定手机号页面
              this.getThirdUser(param).then(() => {
                this.$router.push({
                  path: '/bindphone',
                  query: {
                    appid: this.$route.query.appid,
                    code: this.$route.query.code,
                    state: this.$route.query.state,
                    redirect_uri: this.redirect_uri
                  }
                })
              })
            } else if (response.code === 100001) {
              // 应用程序错误
              this.isWechat && this.wechatLogin()
            }
          })
      } else {
        // 未注册过的也会登录成功
        thirdLogin2(param).then(response => {
          // 支付需要openId，非在艺用户openId
          // this.loginSuccess(response.data)
          this.getThirdUser(param).then(() => {
            this.loginSuccess(response.data)
          })
        })
      }
    },
    // 获取用户openID
    getThirdUser(data) {
      return getThirdUser(data).then(response => {
        let json = JSON.parse(response.data.json)
        // 设置openID
        json.openid &&
          Cookies.set('openId', json.openid, {
            domain: process.env.VUE_APP_COOKIES_DOMAIN,
            expires: 365
          })
      })
    },
    // 检查token
    checkToken() {
      heartbeat().fail(response => {
        Cookies.remove('token', { domain: process.env.VUE_APP_COOKIES_DOMAIN })
      })
    },
    // 登录成功
    loginSuccess(data) {
      // debugger
      Cookies.set('token', data.token, {
        domain: process.env.VUE_APP_COOKIES_DOMAIN,
        expires: 365
      })
      if (this.required_phone === '1' && !data.userInfo.phone) {
        this.$router.push({
          path: '/bindphone',
          query: { redirect_uri: this.redirect_uri }
        })
      } else {
        if (this.redirect_uri) {
          console.log(decodeURIComponent(this.redirect_uri))
          // setTimeout(() => {
          //   location.reload()
          // }, 1000)
            let str = this.redirect_uri
          if (str.indexOf('img.zai-art.com/web/test/webapp/#/') != -1 || str.indexOf('img.zai-art.com/web/prod/webapp/#/') != -1) {
            let urlArr = str.split('#')
                this.$router.push(urlArr[1])
          } else {
          let url = decodeURIComponent(this.redirect_uri)
                let newLink = document.createElement('a')
                newLink.setAttribute('href', url)
                newLink.setAttribute('target', '_self')
                document.getElementsByTagName('body')[0].appendChild(newLink)
                newLink.click()
          }
        } else {
          this.$router.push('/')
        }
      }
    },
    json2Url(json) {
      let paramArr = []
      for (let item in json) {
        if (item === 'url') {
          continue
        }
        if (item === 'redirect_uri') {
          paramArr.push(item + '=' + encodeURIComponent(json[item]))
        } else {
          paramArr.push(item + '=' + json[item])
        }
      }
      return json.url + '?' + paramArr.join('&')
    },
    getImageCode() {
      getCode({ sessionId: this.form.sessionId }).then(response => {
        let { verifyCode } = response.data
        if (verifyCode) {
          this.isShowImageCode = false
          this.form.imageVerifyCode = verifyCode
        } else {
          this.isShowImageCode = true
        }
      })
    }
  },
  created() {
    let query = this.$route.query
    this.redirect_uri = query.redirect_uri || ''
    this.required_phone = query.required_phone || ''
    this.form.phone = query.phone || ''
    this.form.appId = query.appid || ''
    this.form.code = query.code || ''
    this.form.loginType = query.state || ''
    if (query.autologin !== '0') {
      if (query.state && query.code) {
        this.thirdLogin()
      } else {
        if (this.isWechat) {
          // 微信自动登录
          this.wechatLogin()
        }
        if (this.isZaiart) {
          // 在艺自动登录
          this.zaiartLogin()
        }
      }
    }
    // 分享语设置
    share({
      title: '在艺App',
      desc: '爱艺术的人都在这里',
      link: 'https://www.zai-art.com',
      imgUrl: 'https://img.zai-art.com/logo/512.png'
    })
  },
  beforeMount() {
    this.getImageCode()
  }
}
</script>
<style src='@/assets/css/login.css'></style>
